import React, { useState } from 'react'
import { LoadIndicator } from 'devextreme-react'
import ICSButton from '../../../../components/ICS/Button/ICSButton'
import { downloadResultFile, getResultFile } from '../../../../redux/slices'
import { AppDispatch } from '../../../../services/lib'
import { useDispatch } from 'react-redux'
import { showToast } from '../../../../utils/types'
import { ResultFilesDataSourceItem } from '../ResultFilesModal/ResultFilesModal'

export const onDownloadClick = async (
  resultFileId: string,
  dispatch: AppDispatch,
  fileName: string
): Promise<boolean> => {
  const resultFileRes = await dispatch(
    getResultFile({
      resultFileId,
      query: {}
    })
  )

  if (resultFileRes.type.split('/').pop() !== 'fulfilled') {
    return false
  }

  const downloadRes = await dispatch(
    downloadResultFile({
      data: resultFileRes.payload as Blob,
      fileName
    })
  )

  return downloadRes.type.split('/').pop() === 'fulfilled'
}

type RenderActionsProps = {
  row: ResultFilesDataSourceItem
}

const RenderActions: React.FC<RenderActionsProps> = ({ row }) => {
  const dispatch: AppDispatch = useDispatch()
  const [isDownloading, setIsDownloading] = useState(false)
  const validExtensions = ['dsr', 'mf4']
  const fileName = row.name
  const extension = fileName.split('.').pop()?.toLowerCase() || ''
  const hasDataspy = validExtensions.includes(extension)

  const handleDownloadClick = async () => {
    if (isDownloading) {
      return
    }

    setIsDownloading(true)

    // Delay the preparing toast so tiny/fast downloads only show success/error
    // and don't leave a stale "Preparing..." toast after "Download started".
    const preparingToastDelayMs = 500
    const preparingToastTimer = window.setTimeout(() => {
      showToast('Preparing download…', 'info', 2500)
    }, preparingToastDelayMs)

    try {
      const succeeded = await onDownloadClick(
        row.resultFileId,
        dispatch,
        fileName
      )

      window.clearTimeout(preparingToastTimer)

      if (succeeded) {
        showToast('Download started', 'success', 2000)
      } else {
        showToast('Download failed', 'error', 3000)
      }
    } catch {
      window.clearTimeout(preparingToastTimer)
      showToast('Download failed', 'error', 3000)
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <div className="result-files-modal__actions">
      {isDownloading ? (
        <LoadIndicator
          id={`${row.resultFileId}-download-loading`}
          width={24}
          height={24}
        />
      ) : (
        <ICSButton
          id={row.resultFileId}
          key={row.resultFileId}
          icon="download"
          type="default"
          stylingMode="contained"
          onClick={handleDownloadClick}
        />
      )}
      {hasDataspy && (
        <ICSButton
          id={`${row.resultFileId}-dataspy`}
          key={`${row.resultFileId}-dataspy`}
          icon="glyphicons glyphicons-stats"
          type="default"
          stylingMode="contained"
          onClick={() => window.open(row.dataSpy, '_blank')}
        />
      )}
    </div>
  )
}

export default RenderActions
